import React from "react";

const Screen5 = ({ response }) => {
  if (!response || !response.data) {
    return null;
  }

  const { kitsCreated, productsCreated, failedCount } = response.data;

  return (
    <div className="screenfive">
      <h5 className="text-center fw-bold">Record Creation Results </h5>
      <hr />
      <div className="mt-4">
        <p className="text-center mt-2">
          [{kitsCreated}] kits have been successfully imported.
        </p>
        <p className="text-center mt-4">
          [{productsCreated}] products have been successfully imported.
        </p>
        <p className="text-center mt-4">
          [{failedCount}] records were not created.
        </p>
      </div>
    </div>
  );
};

export default Screen5;
